import { render, staticRenderFns } from "./AIAnswerMobile.vue?vue&type=template&id=625493a6&scoped=true"
import script from "./AIAnswerMobile.vue?vue&type=script&lang=js"
export * from "./AIAnswerMobile.vue?vue&type=script&lang=js"
import style0 from "./AIAnswerMobile.vue?vue&type=style&index=0&id=625493a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625493a6",
  null
  
)

export default component.exports